module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/ja_tohoku-66c3731fa6422bfb7914e9a1985ea31b.jpg";